import { memo, useState } from 'react';
import styled from '@emotion/styled';
import {
    GelTooltip,
    GelRowLayout,
    GelLabel,
    GelContainerLite,
    GelCollapsible
} from '@tal-gel/components';
import BenefitType from '../../dashboard/benefitType';
import { getGelTokens } from '@tal-gel/theming';
import IPDetails from './ip-details';
import TPDDetails from './tpd-details';
import { CLAIM_TYPE } from '../../../constants/constants';
import { useGetClaimDetailsContent } from '../../../common/api/graphQLDataFetch';
import { MemberClaims } from '../../../common/models/memberclaims';

interface ClaimBenefitProps {
    claimBenefit: MemberClaims
}
const ClaimBenefit = ({claimBenefit}: ClaimBenefitProps) => {
    const { global: { sizeNone, sizeBaseX2, sizeBase, sizeBaseUnit, themeColorBorderDefault } } = getGelTokens()

    const [showBenefitType, setShowBenefitType] = useState(false);
    const toggleBenefitExpandable = () => setShowBenefitType(!showBenefitType);

    const { data } = useGetClaimDetailsContent()

    const StyledDiv = styled.div(() => ({
        padding: "0px",
        paddingBottom: "20px",
        width: sizeBase * 50
    }));

    const StyledGelLabel = styled(GelLabel)(() => ({
        marginRight: sizeBaseX2
    }));

    const StyledGelTooltip = styled(GelTooltip)(() => ({
        paddingBottom: 5
    }));

    return (
        <GelContainerLite style={{
            borderTop: `${sizeBaseUnit / 4}px solid ${themeColorBorderDefault}`,
            width: "auto",
            cursor: "pointer",
            padding: sizeNone
        }}>
            <GelRowLayout style={{
                borderBottom: `${sizeBaseUnit / 4}px solid ${themeColorBorderDefault}`,
                borderTop: `${sizeBaseUnit / 4}px solid ${themeColorBorderDefault}`,
            }}>
                <BenefitType 
                    claimNumber={claimBenefit.caseNumber} 
                    description={claimBenefit.status.description}
                    friendlyStatus={claimBenefit.status.friendlyStatus}
                    tooltipText={claimBenefit.status.tooltipText}
                    benefitTypeText={claimBenefit.claimTypeName} 
                    showBenefitType={showBenefitType} 
                    isExpandable={true} 
                    toggleBenefitExpandable={toggleBenefitExpandable} />
            </GelRowLayout>

            <GelCollapsible open={showBenefitType}>
                <GelContainerLite style={{ padding: "25px 40px" }}>
                    <GelRowLayout >
                        <StyledDiv>
                            <StyledGelLabel>{data?.detailsHeader}</StyledGelLabel>
                            {[CLAIM_TYPE.IP, CLAIM_TYPE.TPD, CLAIM_TYPE.TI].includes(claimBenefit.claimTypeName) &&
                                <StyledGelTooltip selfAdaptive inline>
                                    {data?.disclaimer}
                                </StyledGelTooltip>}
                        </StyledDiv>
                    </GelRowLayout>

                    {(claimBenefit.claimTypeName === CLAIM_TYPE.IP) &&
                        <IPDetails details={claimBenefit.details} caseManager={claimBenefit.caseManager}/>}
                    {(claimBenefit.claimTypeName === CLAIM_TYPE.TPD || claimBenefit.claimTypeName === CLAIM_TYPE.TI) &&
                        <TPDDetails details={claimBenefit.details} caseManager={claimBenefit.caseManager}/>}
                </GelContainerLite>
            </GelCollapsible>

        </GelContainerLite>
    );
};
export default memo(ClaimBenefit);